/**
 * Extended error.
 */
export class ExtError extends Error {
  readonly name: string = 'ExtError';
  readonly message: string = null;
  readonly faults: Record<string, boolean> = null;
  readonly originalError: Error = null;

  /**
   * Constructor.
   * @param customFaults Custom faults object (optional).
   * @param errorThrown Originally thrown error object (optional).
   */
  constructor(
    customFaults?: Record<string, boolean>,
    errorThrown?: Error,
  ) {
    super();

    this.faults = {
      extError: true,
      ...evalExtErrorFaults(customFaults, errorThrown),
    };

    this.message = evalExtErrorFaultsText(this.faults);
    this.originalError = evalOriginalError(errorThrown);
    if (this.originalError) {
      this.message += `\n${this.originalError}`;
    }
  }
}

/**
 * @hidden
 * Evaluates error faults basing on a faults object and other error.
 */
export function evalExtErrorFaults(
  customFaults: Record<string, boolean>,
  errorThrown: any,
): Record<string, boolean> {
  let errorFaults;
  if (errorThrown && errorThrown.faults) {
    errorFaults = evalExtErrorFaults(errorThrown.faults, errorThrown.originalError);
  }

  const faults = {
    ...(errorFaults || {}),
    ...(customFaults || {}),
  };
  return faults;
}

/**
 * @hidden
 * Evaluates error faults text.
 */
export function evalExtErrorFaultsText(faults: Record<string, boolean>): string {
  const faultsText = Object.keys(faults)
    .filter((faultName) => faults[faultName])
    .join(', ') || '-';
  return faultsText;
}

/**
 * @hidden
 * Evaluates original error of an extended error.
 */
export function evalOriginalError(error: any): Error {
  if (error && error.originalError !== undefined) {
    return evalOriginalError(error.originalError);
  }
  return error || null;
}
